import React from 'react';
import type { FC } from 'react';
import { Box, Text } from '@wix/cli-ui-kit';
import { useTranslation } from '@wix/cli-i18n';

export const WelcomeMessage: FC = () => {
  const { t } = useTranslation();

  return (
    <Box flexDirection="column" marginBottom={1} paddingTop={1}>
      <Text bold>{t('create_app.create_wix_app')}</Text>
    </Box>
  );
};
